var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.245 5.773c2.339-1.045 5.153-1.658 8.465-1.812l-4.8 7.97-3.665-6.157zm16.741 6.113-4.619-7.914c3.204.17 5.938.773 8.222 1.785l-3.604 6.13zm-1.487 2.53a1.304 1.304 0 0 1 .05-1.177l-5.012-8.59-5.513 9.153 5.451 9.158 5.023-8.544zm-7.064 8.875L9.9 15.672l-2.72 4.515a69.74 69.74 0 0 1 .687.331c.605.294 1.327.645 2.147 1.018a44.15 44.15 0 0 0 4.422 1.757zm1.046 2.325c-2.353-.644-4.532-1.542-6.265-2.331l-.573-.265c.736.77 1.589 1.454 2.544 2.03l4.294 2.585v-2.02zm1.922.192 7-2.976a12.217 12.217 0 0 1-2.72 2.22l-4.28 2.576v-1.819zm8.223-5.584-7.082 3.01 4.435-7.544 2.647 4.533zM8.48 14.3a1.306 1.306 0 0 1 .04-.947L4.963 7.377l.58 8.715c.053.81.199 1.605.43 2.374L8.48 14.3zm15.617-.51 2.778 4.758c.245-.794.4-1.617.455-2.456l.584-8.797-3.817 6.494zM4.333 4.57C7.588 2.834 11.64 1.998 16.436 2c4.795 0 8.847.837 12.103 2.57.85.452 1.392 1.344 1.327 2.327l-.62 9.323c-.285 4.29-2.74 8.17-6.572 10.476l-4.85 2.92a2.71 2.71 0 0 1-2.778 0l-4.85-2.92C6.367 24.39 3.91 20.51 3.624 16.22l-.619-9.323c-.065-.982.478-1.874 1.328-2.327z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnx);
export default __webpack_public_path__ + "static/media/ARNX.4560314cf43b620cc453cad3ddef46f3.svg";
export { ForwardRef as ReactComponent };